import { useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { PortalNav } from "@/components/PortalNav";
import { InstCustomers } from "@/components/inst/InstCustomers";
import { InstModeling } from "@/components/inst/InstModeling";
import { Gauge } from "lucide-react";

export default function InstrumentationAdmin() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "customers";
  const tabs = [["customers", "Customers"], ["modeling", "Modeling"]];
  return (
    <div className="min-h-screen bg-[#F4F4F5] md:pl-[var(--sb-w,16rem)]">
      <PortalNav />
      <main className="max-w-[1400px] mx-auto px-4 sm:px-6 py-10" data-testid="inst-admin-page">
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4 }}>
          <p className="text-xs uppercase tracking-[0.25em] text-zinc-400 mb-2">Peregrine Instrumentation</p>
          <h1 className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight text-[#0F172A] flex items-center gap-3">
            <Gauge className="h-8 w-8 text-[#D4AF37]" /> {tab === "modeling" ? "Modeling" : "Customers"}
          </h1>
          <div className="mt-6 flex border-b border-zinc-200">
            {tabs.map(([k, l]) => (
              <button key={k} onClick={() => setSp({ tab: k })} data-testid={`inst-tab-${k}`}
                className={`px-5 py-2.5 text-sm border-b-2 -mb-px transition-colors ${tab === k ? "border-[#D4AF37] text-[#0F172A] font-medium" : "border-transparent text-zinc-500 hover:text-[#0F172A]"}`}>{l}</button>
            ))}
          </div>
          <div className="mt-6">{tab === "modeling" ? <InstModeling /> : <InstCustomers />}</div>
        </motion.div>
      </main>
    </div>
  );
}
